import "../styles/home.css";

import { FaGithub, FaInstagram, FaTwitter } from "react-icons/fa";
import { BiMouse } from "react-icons/bi";
import { useEffect } from "react";

export default function HomePage() {
  // function to navigate between page
  function goTo(elementId) {
    var element = document.getElementById(elementId);
    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }

  // To adjust hieght om mobile devices having address bar appearing diappearing
  useEffect(() => {
    window.addEventListener("resize", function () {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  }, []);

  return (
    <section className="home" id="home">
      <div className="home__container container">
        <div className="home__data">
          <span className="home__greeting">Hello, I'm</span>
          <h1 className="home__name">Vaibhav Aswal</h1>
          <h3 className="home__education">FullStack Developer</h3>

          <div className="home__buttons">
            <a href="https://drive.google.com/file/d/11QpjSbj_iCXbAf2q4kjUoafDSfKhazRn/view" target="_blank" rel="noreferrer" className="btn btn__hollow">
              View CV
            </a>
            <button onClick={() => goTo("about")} className="btn">
              About me
            </button>
          </div>
        </div>

        <div className="home__handle"></div>

        <div className="home__social">
          <a
            href="https://github.com/VaibhavAswal"
            target="_blank"
            rel="noreferrer"
            className="home__social_link"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.instagram.com/vbhv.aswal"
            target="_blank"
            rel="noreferrer"
            className="home__social_link"
          >
            <FaInstagram />
          </a>
          <a
            href="https://twitter.com/vaibhav_says"
            target="_blank"
            rel="noreferrer"
            className="home__social_link"
          >
            <FaTwitter />
          </a>
        </div>

        <button onClick={() => goTo("about")} className="home__scroll">
          <BiMouse className="animated__scroll home__scroll_icon" />
          <span className="home__scroll_name">Scroll Down</span>
        </button>
      </div>
    </section>
  );
}
